import type { FC } from 'react'
import styled from '@emotion/styled'

import sanitizeHtml from 'sanitize-html'

import * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroRecipeBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import DemoForm from '@segment/templates/Forms/DemoForm'

const copy = {
  heading: `Segment’s composable customer data platform`,
  description: [
    {
      paragraph: `We know companies want to choose the software and tools that best meet their business needs—leveraging APIs, pre-built connectors, and an open platform architecture.`,
    },
    {
      paragraph: `Segment can help you collect and govern customer data, and then understand and activate customer profiles. And, Segment’s flexibility and extensibility enables you to move fast, accelerate time to market and scale and evolve your business over time, future-proofing your CDP investment.`,
    },
  ],
}

const Hero: FC = () => {
  return (
    <Wrapper>
      <StyledHeroRecipeBase variant="2Col" copyVariant="wide">
        <HeroRecipe.Copy>
          <CopyText.Heading variant="h1" tag="h1">
            {copy.heading}
          </CopyText.Heading>
          {copy.description.map((text, index) => (
            <CopyText.Description
              key={index}
              tag="p"
              variant="pExtraLarge"
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(text.paragraph, { allowedTags: [`a`] }),
              }}
            />
          ))}
        </HeroRecipe.Copy>
        <HeroRecipe.Contents>
          <HeroRecipe.Form>
            <DemoForm
              customFormIdentifier="site-competitor-composable-demo"
              customTrackingType="site-competitor-composable-demo"
              successMessageAppearance="twilioLight"
            />
          </HeroRecipe.Form>
        </HeroRecipe.Contents>
      </StyledHeroRecipeBase>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.gray[10]};
`

const StyledHeroRecipeBase = styled(HeroRecipeBase)`
  ${HeroRecipe.Wrapper} {
    ${({ theme }) => theme.breakpoints.up(`sm`)} {
      align-items: start;
    }
    ${({ theme }) => theme.breakpoints.up(`xl`)} {
      grid-template-columns: minmax(50%, 640px) minmax(50%, 640px);
    }
  }
`

export default Hero
